module.exports = __webpack_public_path__ + "img/Thumbnail_ZWF_Marcelina_Adamczyk.bc201dc7.jpg";